import { render, staticRenderFns } from "./RegistroDeCambios.vue?vue&type=template&id=44b6483f&scoped=true"
import script from "./RegistroDeCambios.vue?vue&type=script&lang=js"
export * from "./RegistroDeCambios.vue?vue&type=script&lang=js"
import style0 from "./RegistroDeCambios.vue?vue&type=style&index=0&id=44b6483f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b6483f",
  null
  
)

export default component.exports